import Swiper, {Navigation} from 'swiper';

Swiper.use([Navigation]);

export function initSliderFilterContent() {
  let swiper;
  const breakpoint = window.matchMedia('(min-width:769px)');

  function breakpointCheckerContent() {
    if (breakpoint.matches) {
      if (swiper instanceof Swiper) {
        swiper.destroy(true, true);
      }
      return;
    } else {
      if (document.querySelectorAll('.js-filter__swipercontent').length) {
        swiper = new Swiper('.js-filter__swipercontent', {
          slidesPerView: 1,
          loop: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          mousewheel: true,
          keyboard: true,
        });
      }
    }
  }

  breakpointCheckerContent();
  breakpoint.addEventListener('change', breakpointCheckerContent);
}
